import React from 'react';
import { IIconProps } from '../interfaces';

const AleaCopyIcon: React.FC<IIconProps> = ({
  color = '#2B4956',
  size = '22',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size === '22' ? '21' : size}
    viewBox="0 0 22 21"
    fill="none"
  >
    <rect
      x="0.598633"
      y="6.4668"
      width="13.5699"
      height="13.5699"
      rx="2.39303"
      stroke={color}
      strokeWidth="1.19651"
    />
    <rect
      x="7.0293"
      y="0.598633"
      width="13.5699"
      height="13.5699"
      rx="2.39303"
      stroke={color}
      strokeWidth="1.19651"
    />
  </svg>
);

export default AleaCopyIcon;
